import api from '../../../utils/functions/api';

import {
  PROMOTION_WITH_CUSTOMER_TYPE_ALL,
  PROMOTION_WITH_CUSTOMER_TYPE_CREATE,
  PROMOTION_WITH_CUSTOMER_TYPE_GET,
  PROMOTION_WITH_CUSTOMER_TYPE_UPDATE,
  PROMOTION_WITH_CUSTOMER_TYPE_DELETE,
  PROMOTION_WITH_CUSTOMER_TYPE_ERROR,
} from '../types';

// faker.locale = "th"

export const getAllPromotionWithCustomerType = (params) => async (dispatch) => {
  try {
    const { name = '', size = '', page = 1 } = params;
    const { data, status } = await api.get(
      `${process.env.REACT_APP_API_URL}/promotion-with-customer-type?name=${name}&size=${size}&page=${page}`,
    );
    if (status === 200) {
      dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_ALL, payload: data });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_ERROR });
    throw new Error(error);
  }
};

export const getOnePromotionWithCustomerType = (id) => async (dispatch) => {
  await api
    .get(`${process.env.REACT_APP_API_URL}/promotion-with-customer-type/${id}`)
    .then((res) => {
      if (res.data) {
        dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_GET, payload: res.data });
      } else {
        dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_GET, payload: null });
      }
    });
};
export const createOnePromotionWithCustomerType = (payload) => async (
  dispatch,
) => {
  await api
    .post(
      `${process.env.REACT_APP_API_URL}/promotion-with-customer-type/`,
      payload,
    )
    .then(() => {
      console.log('Request Server to Create New option');
      dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_CREATE });
    });
};

export const editOnePromotionWithCustomerType = (id, payload) => async (
  dispatch,
) => {
  await api
    .put(
      `${process.env.REACT_APP_API_URL}/promotion-with-customer-type/${id}`,
      payload,
    )
    .then(() => {
      console.log('Request Server to edit option');
      dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_UPDATE });
    });
};

export const deleteOnePromotionWithCustomerType = (id) => async (dispatch) => {
  await api
    .delete(
      `${process.env.REACT_APP_API_URL}/promotion-with-customer-type/${id}`,
    )
    .then(() => {
      console.log('Request Server to Delete One option');
      dispatch({ type: PROMOTION_WITH_CUSTOMER_TYPE_DELETE, payload: null });
    });
};
